"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Button = _styledComponents.default.button.withConfig({
  displayName: "BubbleIconButton__Button",
  componentId: "design-system__sc-1dnufwh-0"
})(["background-color:#D8D8D8;border-radius:9999px;padding:", ";border:none;display:flex;font-size:", ";;justify-content:center;align-items:center;&:hover{cursor:pointer;}"], _ref => {
  let {
    size
  } = _ref;
  return "".concat(size, "px");
}, _ref2 => {
  let {
    size
  } = _ref2;
  return "".concat(size, "px");
});

const BubbleIconButton = _ref3 => {
  let {
    icon,
    onClick,
    size
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(Button, {
    role: "button",
    onClick: onClick,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: icon,
    size: size
  }));
};

BubbleIconButton.propTypes = {
  icon: _propTypes.default.string,
  size: _propTypes.default.string,
  onClick: _propTypes.default.func
};
BubbleIconButton.defaultProps = {
  icon: 'delete',
  size: '8',
  onClick: () => {}
};
var _default = BubbleIconButton;
exports.default = _default;